import * as types from '../constants/ActionTypes'
import { handleActions } from 'redux-actions'
import moment from 'moment'
import { loadCustomerUploadImg, updateHistoryReport } from '../utils'
import _ from 'lodash';
import cascaderOptions, { DivisionUtil } from '@pansy/china-division';

const divisionUtil = new DivisionUtil(cascaderOptions);
const initialState = {
    searchContent: '',
    channelType: 'client',
    hasLeaveMsg: '',
    searchClientReview: undefined,
    searchIsLostContactCsr: 0,
    searchMajorCaseTypes: [],
    coopTaskTypes: [],
    searchComplaintLevels: [],
    riskLevelId: [],
    kwType: 'flowId',
    isVideoSurvey: '1',
    dateRange: 'all',
    selectedListTab: 'all',
    hasNewImg: undefined,
    searchType: '1',
    reportsList: {
        assigned: {
            list: [],
            pageIndex: 1,
            pageSize: 10,
            count: 0,
            orderBy: 'utime',
            order: 'descend',
            channel: 'client',
            lastUpdataTime: '',
            searchStr: '',
            state: '',
        }, checked: {
            list: [],
            pageIndex: 1,
            pageSize: 10,
            count: 0,
            orderBy: 'utime',
            order: 'descend',
            lastUpdataTime: '',
            channel: 'client',
            searchStr: '',
            state: '',
        }, offline: {
            list: [],
            pageIndex: 1,
            pageSize: 10,
            count: 0,
            orderBy: 'utime',
            order: 'descend',
            lastUpdataTime: '',
            channel: 'client',
            searchStr: '',
            state: '',
        }, all: {
            list: [],
            pageIndex: 1,
            pageSize: 10,
            count: 0,
            orderBy: 'utime',
            order: 'descend',
            lastUpdataTime: '',
            channel: 'client',
            searchStr: '',
            state: '',
        }, untreated: {
            list: [],
            pageIndex: 1,
            pageSize: 10,
            count: 0,
            orderBy: 'utime',
            order: 'descend',
            channel: 'client',
            lastUpdataTime: '',
            searchStr: '',
            state: '',
        }, unhold: {
            list: [],
            pageIndex: 1,
            pageSize: 10,
            count: 0,
            orderBy: 'utime',
            order: 'descend',
            channel: 'client',
            lastUpdataTime: '',
            searchStr: '',
            state: '',
        }, surveied: {
            list: [],
            pageIndex: 1,
            pageSize: 10,
            count: 0,
            orderBy: 'utime',
            order: 'descend',
            channel: 'client',
            lastUpdataTime: '',
            searchStr: '',
            state: '',
        }, holdedOn: {
            list: [],
            pageIndex: 1,
            pageSize: 10,
            count: 0,
            orderBy: 'utime',
            order: 'descend',
            channel: 'client',
            lastUpdataTime: '',
            searchStr: '',
            state: '',
        }, returned: {
            list: [],
            pageIndex: 1,
            pageSize: 10,
            count: 0,
            orderBy: 'utime',
            order: 'descend',
            channel: 'client',
            lastUpdataTime: '',
            searchStr: '',
            state: '',
        }, finished: {
            list: [],
            pageIndex: 1,
            pageSize: 10,
            count: 0,
            orderBy: 'utime',
            order: 'descend',
            channel: 'client',
            lastUpdataTime: '',
            searchStr: '',
            state: '',
        },
        claiming: {
            list: [],
            pageIndex: 1,
            pageSize: 10,
            count: 0,
            orderBy: 'utime',
            order: 'descend',
            channel: 'client',
            lastUpdataTime: '',
            searchStr: '',
            state: '',
        },
        claimReturned: {
            list: [],
            pageIndex: 1,
            pageSize: 10,
            count: 0,
            orderBy: 'utime',
            order: 'descend',
            channel: 'client',
            lastUpdataTime: '',
            searchStr: '',
            state: '',
        },
        tocheck: {
            list: [],
            pageIndex: 1,
            pageSize: 10,
            count: 0,
            orderBy: 'utime',
            order: 'descend',
            channel: 'client',
            lastUpdataTime: '',
            searchStr: '',
            state: '',
        },
        checking: {
            list: [],
            pageIndex: 1,
            pageSize: 10,
            count: 0,
            orderBy: 'utime',
            order: 'descend',
            channel: 'client',
            lastUpdataTime: '',
            searchStr: '',
            state: '',
        },
    },

    currentPreviewReport: {},
    historyReports: [],
    show: 'search',
    signatureState: {},
    handelShowEnhance: false,
    currentOperaPicArr: [],
    allSelectReport: false,
    addCarData: {},
    relevantTableData: {},
    showEvaluationState: '',
    taskInfo: {},
    transferRecords: [],
    activeReportTab: '1',
}
const reducers = {}

reducers[types.SET_REPORT_CHECKED_STATUS] = {
    next(state, action) {
        return Object.assign({}, state, {
            currentPreviewReport: action.payload,
        })
    }
}

reducers[types.GET_LATEST_REPORT_FINISH] = {
    next(state, action) {
        if (!action.error) {
            return Object.assign({}, state, {
                carNumber: action.payload.result.carNumber,
                currentPreviewReport: action.payload.result,
                show: 'update'
            })
        } else {
            return state
        }
    }
}

reducers[types.RELEVANT_REPORT_FINISH] = {
    next(state, action) {
        if (!action.error) {
            return Object.assign({}, state, {
                currentPreviewReport: action.payload.result
            })
        } else {
            return state
        }
    }
}

reducers[types.GET_HISTORY_REPORT_FINISH] = {
    next(state, action) {
        if (!action.error) {
            return Object.assign({}, state, {
                carNumberSearch: action.payload.carNumber,
                historyReports: action.payload.results.list,
                count: action.payload.results.count,
                pageIndex: action.payload.results.pageIndex,
                pageSize: action.payload.results.pageSize
            })
        } else {
            return state
        }
    }
}

reducers[types.SET_CURRENT_REPORT] = {
    next(state, action) {
        let historyReport = state.historyReports.filter(report => report.flowId === action.payload.flowId)[0]
        // let historyReport = state.reportsList.all.list.filter(report => report.flowId === action.payload.flowId)[0]
        return Object.assign({}, state, {
            currentPreviewReport: historyReport || {}
        })
    }
}

reducers[types.CHANGE_ACTIVE_REPORT_TAB] = {
    next(state, action) {
        return Object.assign({}, state, {
            activeReportTab: action.payload.activeKey,
            handelShowEnhance: false
        })
    }
}
reducers[types.UPLOAD_IMG_QUICK_FINISH] = {
    next(state, action) {
        if (!action.error) {
            return Object.assign({}, state, {
                currentPreviewReport: action.payload.result
            })
        } else {
            return state
        }
    }
}

reducers[types.LOAD_CUSTOMER_UPLOAD_IMG] = {
    next(state, action) {
        let reportId = action.payload.imgData.reportId
        let lossId = action.payload.imgData.lossId
        let location = action.payload.imgData.location
        let url = action.payload.imgData.url
        return Object.assign({}, state, {
            currentPreviewReport: loadCustomerUploadImg(state.currentPreviewReport, reportId, lossId, location, url)
        })
    }
}
reducers[types.GET_CREATE_REPORT_OR_DETAILE] = {
    next(state, action) {
        if (action.payload == 'create') {
            return Object.assign({}, state, {
                show: action.payload,
                currentPreviewReport: {}
            })
        } else {
            return Object.assign({}, state, {
                show: action.payload
            })
        }
    }
}

reducers[types.UPLOAD_NOTIFICATION_FINISH] = {
    next(state, action) {
        let reportInfo = state.currentPreviewReport, newRport
        if (reportInfo.flowId == action.payload.data.flowId) {
            newRport = action.payload.data
        } else {
            newRport = reportInfo
        }
        return Object.assign({}, state, {
            notificationKey: Date.now(),
            notificationFlowId: action.payload.data.flowId,
            currentPreviewReport: newRport,
            historyReports: updateHistoryReport(state.historyReports, action.payload.data)
        })
    }
}

reducers[types.UPLOAD_SHOT_PIC_FINISH] = {
    next(state, action) {
        let reportInfo = state.currentPreviewReport, newReport
        if (reportInfo.flowId == action.payload.data.flowId) {
            newReport = action.payload.data
        } else {
            newReport = reportInfo
        }
        return Object.assign({}, state, {
            currentPreviewReport: newReport
        })
    }
}
reducers[types.SHOW_MEASURE_FINISH] = {
    next(state, action) {
        if (action.payload.handelShowEnhance) {
            return Object.assign({}, state, {
                handelShowEnhance: action.payload.handelShowEnhance,
                currentOperaPicArr: [],
                allSelectReport: false
            })
        } else {
            return Object.assign({}, state, {
                currentOperaPicArr: [],
                handelShowEnhance: action.payload.handelShowEnhance,
                allSelectReport: false
            })
        }
    }
}

reducers[types.SHOW_EVALUATION] = (state, action) => {
    return Object.assign({}, state, {
        showEvaluationState: action.payload
    })
}

reducers[types.DEL_PICTURES_FINISH] = (state, action) => {
    return Object.assign({}, state)
}


reducers[types.TRANSFER_RECORDS] = (state, action) => {
    if (!action.error) {
        return Object.assign({}, state, {
            transferRecords: action.payload
        })
    } else {
        return Object.assign({}, state, { transferRecords: [] })
    }
}


reducers[types.CHANGE_DATE_RANGE] = (state, action) => {
    return Object.assign({}, state, { dateRange: action.payload })
}

reducers[types.CHANGE_CHANNEL_TYPE] = (state, action) => {
    return Object.assign({}, state, { channelType: action.payload })
}

reducers[types.CHANGE_HAS_LEAVE_MSG_TYPE] = (state, action) => {
    return Object.assign({}, state, { hasLeaveMsg: action.payload })
}
reducers[types.CHANGE_SEARCH_TYPE_PARAMS] = (state, action) => {
    const data = {};
    ("searchClientReview" in action.payload) && (data.searchClientReview = action.payload.searchClientReview);
    ("searchIsLostContactCsr" in action.payload) && (data.searchIsLostContactCsr = action.payload.searchIsLostContactCsr);
    ("coopTaskTypes" in action.payload) && (data.coopTaskTypes = action.payload.coopTaskTypes);
    ("searchComplaintLevels" in action.payload) && (data.searchComplaintLevels = action.payload.searchComplaintLevels);

    ("riskLevelId" in action.payload) && (data.riskLevelId = action.payload.riskLevelId);

    ("kwType" in action.payload) && (data.kwType = action.payload.kwType);
    ("searchMajorCaseTypes" in action.payload) && (data.searchMajorCaseTypes = action.payload.searchMajorCaseTypes);


    ("hasNewImg" in action.payload) && (data.hasNewImg = action.payload.hasNewImg);

    ("searchType" in action.payload) && (data.searchType = action.payload.searchType);
    return Object.assign({}, state, data)
}
reducers[types.CLEAR_SEARCH_PARAMS] = (state, action) => {
    return Object.assign({}, state, {
        searchContent: '',
        hasLeaveMsg: '',
        searchClientReview: undefined,
        searchIsLostContactCsr: 0,
        searchMajorCaseTypes: [],
        dateRange: 'all',
        coopTaskTypes: [],
        searchComplaintLevels: [],
        riskLevelId: [],
        kwType: 'flowId',
        hasNewImg: undefined
    });
}
reducers[types.CHANGE_VIDEO_SURVEY] = (state, action) => {
    return Object.assign({}, state, { isVideoSurvey: action.payload })
}
reducers[types.CHANGE_SEARCH_INPUT] = (state, action) => {
    return Object.assign({}, state, { searchContent: action.payload })
}

reducers[types.CHANGE_ACTIVE_REPORT_TABLE_TABS] = (state, action) => {
    return Object.assign({}, state, { selectedListTab: action.payload })
}

reducers[types.GET_REPORT_LIST_CLASSIFY_SUCCESS] = (state, action) => {

    let reportlist = { ...state.reportsList }
    reportlist[action.payload.state] = action.payload
    return Object.assign({}, state, { reportsList: reportlist })
}

reducers[types.SEARCH_REPORT_LIST_CLASSIFY_SUCCESS] = (state, action) => {
    return Object.assign({}, state, { reportsList: action.payload })
}

reducers[types.GET_CURRENT_REPORT_FINISH] = (state, action) => {
    return Object.assign({}, state, { currentPreviewReport: action.payload })
}

reducers[types.RESET_REPORT_STATE_SUCCESS] = (state, action) => {
    return Object.assign({}, state, { currentPreviewReport: action.payload })
}

reducers[types.RESET_REPORT_STATE_FAILED] = (state, action) => {
    return Object.assign({}, state, { currentPreviewReport: state.currentPreviewReport })
}
const moment2Date = (date) => {
    if (Array.isArray(date) && date.some(date => date && moment.isMoment(date))) {
        return date.map(dd => moment.isMoment(dd) && new Date(dd.valueOf()));
    }
    if (moment.isMoment(date)) return new Date(date.valueOf());
    return date;
}

reducers[types.UPDATE_REPORT_FORM_DATA] = (state, action) => {
    const { currentPreviewReport = {} } = state;
    const { otherCarLoss = [] } = currentPreviewReport;
    const changeFields = action.payload || {};
    // console.log(changeFields);
    Object.keys(changeFields).forEach(path => {
        let value = changeFields[path];
        let provinceName, cityName, countyName;
        let provinceCode, cityCode, countyCode;
        let branchNo;
        let fieldValue;
        switch (path) {
            case 'accidentDateTime':
                _.set(currentPreviewReport, 'accidentDate', changeFields.accidentDateTime && changeFields.accidentDateTime.format('YYYY-MM-DD') || '');
                _.set(currentPreviewReport, 'accidentTime', changeFields.accidentDateTime && changeFields.accidentDateTime.format('HH:mm:ss') || '');
                break;
            case 'eleme.accidentCause':
                value = {
                    firstLevel: changeFields[0],
                    secondLevel: changeFields[1]
                };
                _.set(currentPreviewReport, path, value);
                break;
            case 'reportProvinceAndCity':
                [provinceName = '', cityName = '', countyName = ''] = changeFields[path] || [];
                let { reportAddress = {}, place = '' } = currentPreviewReport;
                _.set(currentPreviewReport, 'reportAddress', { provinceName, cityName, countyName, addrDetail: reportAddress.addrDetail || place || '' });
                break;
            case 'accidentProvinceAndCity':
                [provinceName = '', cityName = '', countyName = ''] = changeFields[path] || [];
                let { accidentAddress = {}, accidentPlace = '' } = currentPreviewReport;
                _.set(currentPreviewReport, 'accidentAddress', { provinceName, cityName, countyName, addrDetail: accidentAddress.addrDetail || accidentPlace || '' });
                break;
            case 'ownCarLoss.bankCard.dajiaProvinceAndCity':
                [provinceCode, cityCode, countyCode = ''] = changeFields[path] || [];
                _.set(currentPreviewReport, 'ownCarLoss.bankCard.provinceCode', provinceCode)
                _.set(currentPreviewReport, 'ownCarLoss.bankCard.cityCode', cityCode)
                _.set(currentPreviewReport, 'ownCarLoss.bankCard.countyCode', countyCode)


                _.set(currentPreviewReport, 'ownCarLoss.bankCard.province', divisionUtil.getNameByCode(provinceCode))
                _.set(currentPreviewReport, 'ownCarLoss.bankCard.city', divisionUtil.getNameByCode(cityCode))
                break;
            case 'bankProvinceAndCity':
                [provinceName = '', cityName = '', countyName = ''] = changeFields[path] || [];
                _.set(currentPreviewReport, 'ownCarLoss.bankCard.province', provinceName)
                _.set(currentPreviewReport, 'ownCarLoss.bankCard.city', cityName)
                _.set(currentPreviewReport, 'ownCarLoss.bankCard.county', countyName)
                break;
            case 'ownCarLoss.cpicLoss.hospital.provinceCity':
                [provinceName = '', cityName = '', countyName = ''] = changeFields[path] || [];
                const { hospital = {} } = currentPreviewReport && currentPreviewReport.ownCarLoss && currentPreviewReport.ownCarLoss.cpicLoss || {};
                const { address: hospitalAddr = {} } = hospital;
                _.set(currentPreviewReport, 'ownCarLoss.cpicLoss.hospital.address', { provinceName, cityName, countyName, addrDetail: hospitalAddr.addrDetail || '' });
                break;
            case 'cpic.reportEventType':
                let [eventType = '', subEventType = ''] = changeFields[path] || [];
                value = { eventType, subEventType };
                _.set(currentPreviewReport, path, value);
                break;
            case 'ownCarLoss.bankCard.accountBank':
                const { num, bankNo } = currentPreviewReport && currentPreviewReport.ownCarLoss && currentPreviewReport.ownCarLoss.bankCard || {};
                [provinceCode = '', cityCode = '', branchNo = ''] = changeFields[path];
                _.set(currentPreviewReport, 'ownCarLoss.bankCard', { bankNo, provinceCode, cityCode, branchNo, num });
                break;
            case 'ownCarLoss.cpicLoss.illegalBehavior':
                let [firstType = '', secondType = ''] = changeFields[path] || [];
                value = { firstType, secondType };
                _.set(currentPreviewReport, path, value);
                break;
            case 'ownCarLoss.cpicLoss.isInjury':

                fieldValue = changeFields[path];
                if (
                    (Object.prototype.toString.call(fieldValue) === '[object Boolean]' &&
                        fieldValue) ||
                    fieldValue === '1'
                ) {
                    value = '1';
                } else {
                    value = '0';
                }
                _.set(currentPreviewReport, path, value);
                break;
            case 'ownCarLoss.payee.directPay':

                fieldValue = changeFields[path];
                if (
                    (Object.prototype.toString.call(fieldValue) === '[object Boolean]' &&
                        fieldValue) ||
                    fieldValue === '1'
                ) {
                    value = '1';
                } else {
                    value = '0';
                }
                _.set(currentPreviewReport, path, value);
                break;
            case 'ownCarLoss.payee.certDate':
                const [certStartDate, certEndDate] = Array.isArray(value) ? value.map(date => moment.isMoment(date) ? date.format('YYYY-MM-DD') : date) : [];
                _.set(currentPreviewReport, `ownCarLoss.payee.certStartDate`, certStartDate);
                _.set(currentPreviewReport, `ownCarLoss.payee.certEndDate`, certEndDate);
                break;
            case 'ownCarLoss.payee.certStartDate':
                const certStartDateStr = moment.isMoment(value) ? value.format('YYYY-MM-DD') : value;
                _.set(currentPreviewReport, 'ownCarLoss.payee.certStartDate', certStartDateStr);
                break;
            case 'ownCarLoss.payee.certEndDate':
                const certEndDateStr = moment.isMoment(value) ? value.format('YYYY-MM-DD') : value;
                _.set(currentPreviewReport, 'ownCarLoss.payee.certEndDate', certEndDateStr);
                break;
            default:
                if (/otherCarLoss\[[\d+]\]\.cpicLoss\.(carLossParts|carLossDetail)/.test(path)) {
                    value = changeFields[path].join(',');
                } else if (/otherCarLoss\[([\d+])\]\.bankCard\.accountBank/.test(path)) {
                    const lossIndex = RegExp.$1;
                    const curLoss = otherCarLoss[lossIndex] || {};
                    const { num, bankNo } = curLoss.bankCard || {};
                    let [provinceCode = '', cityCode = '', branchNo = ''] = changeFields[path] || [];
                    _.set(currentPreviewReport, `otherCarLoss[${lossIndex}].bankCard`, { bankNo, provinceCode, cityCode, branchNo, num });
                } else if (/otherCarLoss\[([\d+])\]\.cpicLoss\.hospital\.provinceCity/.test(path)) {
                    const lossIndex = RegExp.$1;
                    const curLoss = otherCarLoss[lossIndex] || {};
                    const { address: otherHospitalAddr = {} } = curLoss.cpicLoss && curLoss.cpicLoss.hospital || {};
                    [provinceName = '', cityName = '', countyName = ''] = changeFields[path] || [];
                    _.set(currentPreviewReport, `otherCarLoss[${lossIndex}].cpicLoss.hospital.address`, Object.assign(otherHospitalAddr, { provinceName, cityName, countyName }));
                } else if (/otherCarLoss\[([\d+])\]\.cpicLoss\.carRepairOrgAddr\.provinceCity/.test(path)) {
                    const lossIndex = RegExp.$1;
                    const curLoss = otherCarLoss[lossIndex] || {};
                    const { carRepairOrgAddr = {} } = curLoss.cpicLoss || {};
                    [provinceName = '', cityName = '', countyName = ''] = changeFields[path] || [];
                    _.set(currentPreviewReport, `otherCarLoss[${lossIndex}].cpicLoss.carRepairOrgAddr`, Object.assign(carRepairOrgAddr, { provinceName, cityName, countyName }));
                } else if (/otherCarLoss\[([\d+])\]\.cpicLoss\.damageRepairOrgAddr\.provinceCity/.test(path)) {
                    const lossIndex = RegExp.$1;
                    const curLoss = otherCarLoss[lossIndex] || {};
                    const { damageRepairOrgAddr = {} } = curLoss.cpicLoss || {};
                    if (changeFields[path]) [provinceName = '', cityName = '', countyName = ''] = changeFields[path] || [];
                    _.set(currentPreviewReport, `otherCarLoss[${lossIndex}].cpicLoss.damageRepairOrgAddr`, Object.assign(damageRepairOrgAddr, { provinceName, cityName, countyName }));
                } else if (/otherCarLoss\[([\d+])\]\.cpicLoss\.(isInjury|isDamage|isCarLoss)/.test(path) || /otherCarLoss\[([\d+])\]\.payee\.(directPay)/.test(path)) {

                    let fieldValue = changeFields[path];
                    if (
                        (Object.prototype.toString.call(fieldValue) === '[object Boolean]' &&
                            fieldValue) ||
                        fieldValue === '1'
                    ) {
                        value = '1';
                    } else {
                        value = '0';
                    }
                } else if (/otherCarLoss\[([\d+])\]\.payee\.certDate/.test(path)) {
                    const lossIndex = RegExp.$1;
                    const [certStartDate, certEndDate] = Array.isArray(value) ? value.map(date => moment.isMoment(date) ? date.format('YYYY-MM-DD') : date) : [];
                    _.set(currentPreviewReport, `otherCarLoss[${lossIndex}].payee.certStartDate`, certStartDate);
                    _.set(currentPreviewReport, `otherCarLoss[${lossIndex}].payee.certEndDate`, certEndDate);
                } else if (/otherCarLoss\[([\d+])\]\.payee\.certStartDate/.test(path)) {
                    const lossIndex = RegExp.$1;
                    const certStartDateStr = moment.isMoment(value) ? value.format('YYYY-MM-DD') : value;
                    _.set(currentPreviewReport, `otherCarLoss[${lossIndex}].payee.certStartDate`, certStartDateStr);
                } else if (/otherCarLoss\[([\d+])\]\.payee\.certEndDate/.test(path)) {
                    const lossIndex = RegExp.$1;
                    const certEndDateStr = moment.isMoment(value) ? value.format('YYYY-MM-DD') : value;
                    _.set(currentPreviewReport, `otherCarLoss[${lossIndex}].payee.certEndDate`, certEndDateStr);
                }
                else if (moment.isMoment(value) || (Array.isArray(value) && value.some(date => date && moment.isMoment(date)))) {
                    value = moment2Date(value);
                } else if (/otherCarLoss\[([\d+])\]\.bankCard\.(dajiaProvinceAndCity)/.test(path)) {
                    const lossIndex = RegExp.$1;
                    const [provinceCode, cityCode, countyCode = ''] = changeFields[path] || [];

                    _.set(currentPreviewReport, `otherCarLoss[${lossIndex}].bankCard.provinceCode`, provinceCode)
                    _.set(currentPreviewReport, `otherCarLoss[${lossIndex}].bankCard.cityCode`, cityCode)
                    _.set(currentPreviewReport, `otherCarLoss[${lossIndex}].bankCard.countyCode`, countyCode)


                    _.set(currentPreviewReport, `otherCarLoss[${lossIndex}].bankCard.province`, divisionUtil.getNameByCode(provinceCode))
                    _.set(currentPreviewReport, `otherCarLoss[${lossIndex}].bankCard.city`, divisionUtil.getNameByCode(cityCode))

                    break;
                }
                _.set(currentPreviewReport, path, value);
        }
    });

    return Object.assign({}, state, { currentPreviewReport })
}

reducers[types.ADD_OR_REDUCE_REPORT_ITEMS] = (state, action) => {
    const currentPreviewReport = Object.assign(state.currentPreviewReport, action.payload);
    return Object.assign({}, state, { currentPreviewReport })
}

export default handleActions(reducers, initialState)

